export const FUNDAMENT_PREFIX = 'fm-';
